import { FC, useState } from "react";
import { useSelector } from "react-redux";
import { ConfirmationDialog } from "../../../../components/ConfirmationDialog";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { ReactComponent as EmailIcon } from "../../../../assets/images/Email.svg";
import { ReactComponent as PhoneIcon } from "../../../../assets/images/phone.svg";
import { ReactComponent as ProfileIcon } from "../../../../assets/images/User-profile.svg";
import { ReactComponent as PasswordIcon } from "../../../../assets/images/lock-password.svg";
import { ReactComponent as PencilIcon } from "../../../../assets/images/edit.svg";
import { ReactComponent as ForgotPasswordIcon } from "../../../../assets/images/forgot-password.svg";
import { ReactComponent as AutoCorrectIcon } from "../../../../assets/images/Auto-Correct.svg";
import { ReactComponent as LanguageIcon } from "../../../../assets/images/Language.svg";
import { ReactComponent as ColorSchemeIcon } from "../../../../assets/images/Color.svg";
import { ReactComponent as TermsIcon } from "../../../../assets/images/Terms-Condition.svg";
import { ReactComponent as PrivacyPolicyIcon } from "../../../../assets/images/Privacy-Policy.svg";
import { ReactComponent as ArrowRightIcon } from "../../../../assets/images/Arrow-right.svg";
import "./index.css";
import { JSX } from "react/jsx-runtime";
import TextInput from "../../../../components/TextInput";
import {
  useManageSubscriptionQuery,
  useUpdateUserPreferencesMutation,
  useUpdateUserProfileMutation,
} from "../../../../services/user";
import Grid from "@mui/material/Grid2";
import { errorToast, successToast } from "../../../../utils/toast";
import { CustomButton } from "../../../../components/Button";
import { useNavigate } from "react-router-dom";
import React from "react";
const UserInfoTab: FC = () => {
  const navigate = useNavigate();
  const metaData = useSelector((state: any) => state.metaData);
  const paymentLinks = metaData.stripe.paymentLinks;
  const username = metaData.userInfo["cognito:username"];
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [managePlan, setManagePlan] = useState(false);
  const [updateProfile] = useUpdateUserProfileMutation();
  const [updatePreferences] = useUpdateUserPreferencesMutation();
  const userInfo = metaData.userInfo;
  const manageSubscription = useManageSubscriptionQuery(
    `?username=${username}`,
    { skip: !managePlan }
  );
  const [confirmationProps, setConfirmationProps] = useState<any>({
    title: "",
    content: "",
    btn1: "",
    btn2: "",
    handleBtn1: () => {},
    handleBtn2: () => {},
    icon: <div></div>,
    tooltip: "",
    bgcolor: "",
  });
  const defaultDialogProps = () => {
    return {
      title: "",
      content: "",
      btn1: "",
      btn2: "",
      handleBtn1: () => {},
      handleBtn2: () => {},
      actions: true,
      icon: <div></div>,
      bgcolor: "",
    };
  };
  let tempConfirmationProps = defaultDialogProps();

  React.useEffect(() => {
    if (!manageSubscription.isFetching) {
      if (manageSubscription.isSuccess) {
        if (manageSubscription.data && manageSubscription.data.url) {
          window.location.href = manageSubscription.data.url;
          setManagePlan(false);
        } else {
          setManagePlan(false);
        }
      }
    }
  }, [manageSubscription.isFetching]);

  const [infoProps, setInfoProps] = useState([
    {
      key: "email",
      type: "string",
      value: userInfo.email,
      check: false,
      icon: <EmailIcon />,
      label: "",
      disabled: false,
    },
    {
      key: "firstName",
      label: "First Name",
      type: "string",
      check: false,
      value: userInfo.firstName,
      icon: <ProfileIcon />,
      endIcon: (
        <PencilIcon
          style={{ cursor: "pointer" }}
          onClick={() => enablePropEdit("firstName", true, "info")}
        />
      ),
      disabled: false,
    },
    {
      key: "lastName",
      label: "Last Name",
      type: "string",
      value: userInfo.lastName,
      check: false,
      icon: <ProfileIcon />,
      endIcon: (
        <PencilIcon
          style={{ cursor: "pointer" }}
          onClick={() => enablePropEdit("lastName", true, "info")}
        />
      ),
      disabled: false,
    },
    {
      key: "phone",
      label: "Phone",
      type: "string",
      value: userInfo.phone,
      check: false,
      icon: <PhoneIcon />,
      endIcon: (
        <PencilIcon
          style={{ cursor: "pointer" }}
          onClick={() => enablePropEdit("phone", true, "info")}
        />
      ),
      disabled: false,
    },
    {
      key: "password",
      type: "string",
      value: "***********",
      check: false,
      icon: <PasswordIcon />,
      endIcon: <ForgotPasswordIcon />,
      label: "",
      disabled: false,
    },
  ]);
  const [preferencesProps, setPreferencesProps] = useState([
    {
      key: "appLanguage",
      label: "App Language",
      type: "string",
      check: false,
      value: userInfo.preferences.appLanguage,
      icon: <LanguageIcon />,
      // endIcon: (
      //   <PencilIcon
      //     style={{ cursor: "pointer" }}
      //     onClick={() => enablePropEdit("appLanguage", true, "preferences")}
      //   />
      // ),
      disabled: false,
    },
    // {
    //   key: "globalPersonality",
    //   label: "Global Personality",
    //   type: "string",
    //   check: false,
    //   value: userInfo.preferences.globalPersonality,
    //   icon: <LanguageIcon />,
    //   endIcon: (
    //     <PencilIcon
    //       style={{ cursor: "pointer" }}
    //       onClick={() =>
    //         enablePropEdit("globalPersonality", true, "preferences")
    //       }
    //     />
    //   ),
    //   disabled: false,
    // },
    {
      key: "colorScheme",
      label: "Color scheme",
      type: "string",
      value: "",
      check: false,
      icon: <ColorSchemeIcon />,
      disabled: true,
    },
    {
      key: "autoCorrect",
      label: "Auto-correct",
      type: "string",
      value: "",
      check: false,
      icon: <AutoCorrectIcon />,
      disabled: true,
    },
  ]);
  const [termsProps, setTermsProps] = useState([
    {
      key: "",
      type: "string",
      value: "",
      check: false,
      icon: <TermsIcon />,
      endIcon: (
        <ArrowRightIcon
          style={{ cursor: "pointer" }}
          onClick={() =>
            window.open("https://hiibo.app/termsandconditions", "_blank")
          }
        />
      ),
      label: "Terms of use",
      disabled: false,
    },
    {
      key: "",
      type: "string",
      value: "",
      check: false,
      icon: <PrivacyPolicyIcon />,
      endIcon: (
        <ArrowRightIcon
          style={{ cursor: "pointer" }}
          onClick={() =>
            window.open("https://hiibo.app/privacy-policy", "_blank")
          }
        />
      ),
      label: "Privacy policy",
      disabled: false,
    },
  ]);

  const enablePropEdit = (key: string, check: boolean, type: string) => {
    let props: any =
      type == "preferences" ? [...preferencesProps] : [...infoProps];
    props.forEach((prop: any) => (prop.check = false));
    let selectedProp = props.find((prop: any) => prop.key == key);
    if (selectedProp) {
      selectedProp.check = check;
    }
    type == "preferences" ? setPreferencesProps(props) : setInfoProps(props);
  };

  const proceedPropEdit = async (key: string, type: string) => {
    const label = (type == "preferences" ? preferencesProps : infoProps).find(
      (prop) => prop.key == key
    )?.label;
    tempConfirmationProps = {
      title: "WARNING",
      bgcolor: "rgba(180, 69, 52, 1)",
      content: `Are you sure you want to update your ${label}?`,
      btn1: "Cancel",
      btn2: "",
      handleBtn1: () => setShowConfirmation(false),
      handleBtn2: () => {},
      actions: true,
      icon: <div></div>,
    };
    setConfirmationProps(tempConfirmationProps);
    const body =
      type == "preferences"
        ? {
            body: {
              [key]: preferencesProps.find((prop) => prop.key == key)?.value,
            },
            params: `?username=${username}`,
          }
        : {
            [key]: infoProps.find((prop) => prop.key == key)?.value,
            username,
          };
    const response: any =
      type == "preferences"
        ? await updatePreferences(body)
        : await updateProfile(body);
    if (response.error) {
      errorToast(
        response.error.error ||
          (response.error.data && response.error.data.message)
      );
      tempConfirmationProps = {
        title: "WARNING",
        bgcolor: "rgba(180, 69, 52, 1)",
        content: `Are you sure you want to update your ${label}?`,
        btn1: "Cancel",
        btn2: "Proceed",
        handleBtn1: () => setShowConfirmation(false),
        handleBtn2: () => proceedPropEdit(key, type),
        actions: true,
        icon: <div></div>,
      };
      setConfirmationProps(tempConfirmationProps);
    } else {
      successToast(`${label} updated successfully`);
      enablePropEdit(key, false, "info");
      setShowConfirmation(false);
      setConfirmationProps(defaultDialogProps());
    }
  };

  const confirmPropEdit = (key: string, type: string) => {
    const selectedProperty = (
      type == "preferences" ? preferencesProps : infoProps
    ).find((prop) => prop.key == key);
    const label = selectedProperty?.label;
    if (!selectedProperty?.value) {
      errorToast(`${label} can not be empty`);
      return;
    }
    if (
      key == "phone" &&
      !/^([0|\+[0-9]{1,5})?([0-9]{10})$/.test(selectedProperty?.value)
    ) {
      errorToast(`Invalid phone number`);
      return;
    }
    setShowConfirmation(true);
    tempConfirmationProps = {
      title: "WARNING",
      bgcolor: "rgba(180, 69, 52, 1)",
      content: `Are you sure you want to update your ${label}?`,
      btn1: "Cancel",
      btn2: "Proceed",
      handleBtn1: () => setShowConfirmation(false),
      handleBtn2: () => proceedPropEdit(key, type),
      actions: true,
      icon: <div></div>,
    };
    setConfirmationProps(tempConfirmationProps);
  };

  const changeInfoProp = (e: any, key: string, type: string) => {
    let props = type == "preferences" ? [...preferencesProps] : [...infoProps];
    let selectedProp = props.find((prop) => prop.key == key);
    if (selectedProp) {
      selectedProp.value = e.target.value;
    }
    type == "preferences" ? setPreferencesProps(props) : setInfoProps(props);
  };

  const userProperties = (
    prop:
      | {
          key: string;
          type: string;
          value: string;
          label: string;
          check: boolean;
          disabled: boolean;
          icon: JSX.Element;
          endIcon: JSX.Element;
        }
      | {
          key: string;
          type: string;
          value: string;
          label: string;
          check: boolean;
          disabled: boolean;
          icon: JSX.Element;
          endIcon?: undefined;
        },
    type: string
  ) => {
    return (
      <>
        <div className="info-prop">
          <div className={prop.disabled ? "disabled-prop-icon" : "prop-icon"}>
            {prop.icon}
          </div>
          <div className={prop.disabled ? "disabled-prop-value" : "prop-value"}>
            {prop.check ? (
              <TextInput
                defaultValue={prop.value || ""}
                width="100%"
                color="#218f54 !important"
                handleChange={(e) => changeInfoProp(e, prop.key, type)}
              />
            ) : (
              prop.value || prop.label
            )}
          </div>
          {prop.endIcon ? (
            <div className="prop-edit">
              {prop.check ? (
                <Checkbox
                  checked
                  sx={{
                    padding: "9px 0px",
                    "&.Mui-checked": {
                      color: "#218f54", // checked color
                    },
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                  onClick={() => confirmPropEdit(prop.key, type)}
                />
              ) : (
                prop.endIcon
              )}
            </div>
          ) : null}
        </div>
        <Divider sx={{ backgroundColor: "#218f5441", margin: "10px 0px" }} />
      </>
    );
  };

  const subscriptionCard = (props: {
    name: string;
    fee: string;
    type: string;
    memoryChanges: number;
    automations: number;
    status: string;
    selected: boolean;
    disabled: boolean;
  }) => {
    return (
      <Card
        sx={{
          backgroundColor: props.selected
            ? "#218f5470"
            : props.disabled
            ? "#10281d57"
            : "#10281d57", // green background
          borderRadius: "10px",
          opacity: props.disabled ? 0.5 : 1,
          padding: "12px",
          boxShadow: 3,
          width: "100% !important",
          height: "200px",
        }}
      >
        <CardContent sx={{ p: 0, paddingBottom: "0px !important" }}>
          <Box sx={{ height: "140px" }}>
            <Stack direction="row" alignItems="center" gap={"5px"}>
              <Typography
                fontFamily={"Poppins"}
                variant="h5"
                fontWeight="bold"
                color="white"
              >
                {props.name}
              </Typography>
              <Box sx={{ flex: 1 }}>
                <Chip
                  label={props.status}
                  size="small"
                  sx={{
                    backgroundColor: "#223F31", // dark background
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    borderRadius: "6px",
                    fontFamily: "Poppins !important",
                  }}
                />
              </Box>
              <Box>
                <Typography
                  fontFamily={"Poppins"}
                  variant="h6"
                  color="white"
                  fontSize={12}
                >
                  {props.fee}
                  <Typography
                    fontFamily={"Poppins"}
                    component="span"
                    variant="body2"
                    color="white"
                    fontSize={12}
                  >
                    /mo
                  </Typography>
                </Typography>
                <Typography
                  fontFamily={"Poppins"}
                  variant="body2"
                  color="white"
                  fontSize={12}
                >
                  {props.type || " "}
                </Typography>
              </Box>
            </Stack>

            <Box mb={2} mt={2}>
              <Typography fontFamily={"Poppins"} color="white">
                Chat - ∞
              </Typography>
              <Typography fontFamily={"Poppins"} color="white">
                Memory changes - {props.memoryChanges}
              </Typography>
              <Typography fontFamily={"Poppins"} color="white">
                Automations - {props.automations}
              </Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            fullWidth
            disabled={props.disabled}
            sx={{
              backgroundColor: "#48b467", // lighter green disabled button
              color: "#1d1d1d",
              fontWeight: "bold",
              borderRadius: "12px",
              textTransform: "none",
              //   marginTop: props.name == "Yearly" ? "20px" : "0px",
              "&.Mui-disabled": {
                backgroundColor: "#48b467", // keep color even if disabled
                color: "#1d1d1d",
                opacity: 1, // remove default opacity of disabled
              },
              fontFamily: "Poppins !important",
            }}
            onClick={() => {
              if (userInfo.subscriptionStatus == "Freemium") {
                window.location.href = paymentLinks.find(
                  (payment: { name: string | string[] }) =>
                    payment.name.includes("Alpha Access")
                ).url;
              } else {
                setManagePlan(true);
              }
            }}
          >
            {userInfo.subscriptionStatus == "Freemium" ? (
              "Upgrade plan"
            ) : props.name == "Monthly" && manageSubscription.isLoading ? (
              <CircularProgress size={25} />
            ) : props.name == "Monthly" && !manageSubscription.isLoading ? (
              "Manage plan"
            ) : (
              "Upgrade plan"
            )}
          </Button>
        </CardContent>
      </Card>
    );
  };

  return (
    <div>
      <div className="usersinfo">
        <Typography fontFamily={"Poppins"}>User Info</Typography>
      </div>
      <Box
        sx={{
          border: "1px solid #218F54",
          borderRadius: "8px",
          width: "100%",
          maxHeight: "600px",
          margin: "20px 0px",
          padding: "10px 15px",
        }}
      >
        {infoProps.map((prop) => userProperties(prop, "info"))}
      </Box>
      <div className="usersinfo">
        <Typography fontFamily={"Poppins"}>Preferences</Typography>
      </div>
      <Box
        sx={{
          border: "1px solid #218F54",
          borderRadius: "8px",
          width: "100%",
          maxHeight: "600px",
          margin: "20px 0px",
          padding: "10px 15px",
        }}
      >
        {preferencesProps.map((prop) => userProperties(prop, "preferences"))}
      </Box>
      <div className="usersinfo">
        <Typography fontFamily={"Poppins"}>Subscription</Typography>
      </div>
      <Box
        sx={{
          width: "100%",
          maxHeight: "600px",
          margin: "20px 0px",
          //   padding: "10px 15px",
        }}
      >
        <Grid container spacing={"24px"}>
          <Grid
            size={{ xs: 4, md: 4 }}
            display={"flex"}
            justifyContent={"center"}
          >
            {subscriptionCard({
              name: "Freemium",
              fee: "$0",
              status: "Active",
              type: "free",
              memoryChanges: 5,
              automations: 5,
              selected:
                userInfo.subscriptionStatus == "Freemium" ? true : false,
              disabled:
                userInfo.subscriptionStatus == "Freemium" ? false : true,
            })}
          </Grid>
          <Grid
            size={{ xs: 4, md: 4 }}
            display={"flex"}
            justifyContent={"center"}
          >
            {subscriptionCard({
              name: "Monthly",
              fee: "$5",
              status: "Save 10%",
              type: "popular",
              memoryChanges: 250,
              automations: 500,
              selected: userInfo.subscriptionStatus == "Active" ? true : false,
              disabled: userInfo.subscriptionStatus == "Active" ? false : true,
            })}
          </Grid>
          <Grid
            size={{ xs: 4, md: 4 }}
            display={"flex"}
            justifyContent={"center"}
          >
            {subscriptionCard({
              name: "Yearly",
              fee: "$100",
              status: "Active",
              type: "",
              memoryChanges: 5,
              automations: 1500,
              selected: false,
              disabled: true,
            })}
          </Grid>
        </Grid>
      </Box>
      <div className="usersinfo">
        <Typography fontFamily={"Poppins"}>Terms & Conditions</Typography>
      </div>
      <Box
        sx={{
          border: "1px solid #218F54",
          borderRadius: "8px",
          width: "100%",
          maxHeight: "600px",
          margin: "20px 0px",
          padding: "10px 15px",
        }}
      >
        {termsProps.map((prop) => userProperties(prop, "terms"))}
      </Box>
      <div className="back-btn">
        <CustomButton
          text="Back to Chat"
          submit={() => navigate("/chat")}
          variant="outlined"
          width="25%"
          height="40px"
        />
      </div>
      {showConfirmation ? (
        <ConfirmationDialog
          open={showConfirmation}
          content={confirmationProps.content}
          title={confirmationProps.title}
          btn1={confirmationProps.btn1}
          btn2={confirmationProps.btn2}
          handleBtn1={confirmationProps.handleBtn1}
          handleBtn2={confirmationProps.handleBtn2}
          icon={confirmationProps.icon}
          actions={confirmationProps.actions}
          tooltip={confirmationProps.tooltip}
          bgcolor={confirmationProps.bgcolor}
        />
      ) : null}
    </div>
  );
};

export default UserInfoTab;
